import React from 'react';
import Appbar from 'components/appbar/Appbar';
import ProductAction from './ProductAction';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import { useFetchProducts } from './hooks/useFetchProducts';
import ProductFilterBox from './ProductFilterBox';
import Pagination from 'components/pagination/Pagination';
import ProductListTable from './list/table/ProductListTable';
import ProductListModule from './list/module/ProductListModule';
import { useDisplayMode } from 'hooks/useDisplayMode';
import PaginationProvider from 'hooks/pagination';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';
import NoData from 'components/no-data/NoData';

const Product: React.FC = () => {
  const {
    products,
    loading,
    orderedIndex,
    handleSort,
    filter,
    handleChange,
    setPage,
    setRows,
    handleSearch,
    page,
    rows,
    total,
  } = useFetchProducts();
  const [displayMode] = useDisplayMode();
  return (
    <>
      <Appbar title="Produtos" ActionsComponent={<ProductAction />} />
      <PageHeaderActions
        title="Produtos"
        description="Gestão de produtos"
        ActionComponent={<NewRecordButton label="Novo produto" to="/products/new" />}
      />

      <ProductFilterBox filter={filter} handleChange={handleChange} handleSearch={handleSearch} loading={loading} />

      <PaginationProvider rowsPerPage={rows}>
        {loading ? (
          displayMode === 'list' ? (
            <TableLoading />
          ) : (
            <ModuleLoading />
          )
        ) : products.length === 0 ? (
          <NoData message="Nenhum produto encontrado" />
        ) : (
          <>
            {displayMode === 'list' ? (
              <ProductListTable products={products} />
            ) : (
              <ProductListModule products={products} />
            )}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </>
        )}
      </PaginationProvider>
    </>
  );
};

export default Product;
